export default {
  name: 'streak',
  defaultEndpoints: false,
  endpoints: [
    {
      method: 'GET',
      endpoint: '/info',
      hasParams: false,
      alias: 'info'
    },
    {
      method: 'GET',
      endpoint: '/settings',
      hasParams: false,
      alias: 'settings'
    },
    {
      method: 'PUT',
      endpoint: '/settings',
      hasParams: false,
      hasBody: true,
      alias: 'updateSettings'
    },
    {
      method: 'GET',
      endpoint: '/settings/verify',
      hasParams: false,
      alias: 'verifySettings'
    },
    {
      method: 'GET',
      endpoint: '/clients/:clientId/status',
      hasParams: true,
      alias: 'clientStatus'
    },
    {
      method: 'POST',
      endpoint: '/sync/clients',
      hasParams: false,
      hasBody: true,
      alias: 'syncClients'
    },
    {
      method: 'POST',
      endpoint: '/sync',
      hasParams: false,
      hasBody: false,
      alias: 'reconcile'
    }
  ]
}
